module.exports = __webpack_public_path__ + "static/media/carousel-image-three.28089d14.png";